import { connect } from 'react-redux'
import Tag from './Tag.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsTag.chartType,
    granularity: state.analyticsTag.granularity,
    dateRange: state.analyticsTag.dateRange,
    customDateRange: state.analyticsTag.customDateRange,
    channelNameToFilter: state.analyticsTag.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.tagChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.tagChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.tagMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.tagChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.tagChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tag)
